import { render, staticRenderFns } from "./EshopOrderDetail.vue?vue&type=template&id=60dbf04a"
import script from "./EshopOrderDetail.vue?vue&type=script&lang=js"
export * from "./EshopOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports